/**
 * 浏览器兼容性检测
 * @returns 
 */
const browserCheck = () => {
    return `
            <script type="text/javascript">
                (function () {
                    var ua = window.navigator.userAgent;
                    var isFirefox = ua.indexOf("Firefox") != -1;
                    var isChrome = ua.indexOf("Chrome") != -1;
                    var isCriOS = ua.indexOf("CriOS") != - 1;
                    var isEdge = ua.indexOf("Edg") != -1;
                    var edgeVersion = isEdge && ((ua.split('/') || []).pop().split('.') || [])[0];
                    if (!isFirefox && !isChrome && !isCriOS || isEdge && edgeVersion < 79) {
                        window.location.href = '/support/browserupgrade'
                    }
                })();
            </script>
        `;
};

export default browserCheck;